import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { ErrorBoundary } from '@sainsburys-tech/bolt'

import Price from '../../components/Price/Price'
import Alert from '../../components/Alert/Alert'
import AttributeSelector from '../../components/AttributeSelector/AttributeSelector'
import FulfilmentBoxContainer from '../../components/FulfilmentBox/FulfilmentBoxContainer'
import GenericFlag from '../../components/GenericFlag/GenericFlag'
import WishList from '../../components/WishList/WishList'
import OrderSwatch from '../../components/OrderSwatch/OrderSwatch'
import PromotionContainer from '../../components/Promotion/PromotionContainer'
import EssentialExtras from '../../components/EssentialExtras/EssentialExtras'
import PayPalContainer from '../../components/Paypal/PayPalContainer'
import KlarnaMessaging from '../../components/Klarna/KlarnaMessaging'
import FinanceAccordion from '../../components/AFSCredit/components/FinanceAccordion/FinanceAccordion'
import { getPreferredCreditPlans } from '../../helpers/creditPlanHelper'
import { KLARNA_PROVIDED } from '../../helpers/FinanceProviderConstants'

import { AvailabilityDataLayer } from '../../containers'

import { project } from '../../utils'

import AddToTrolleySection from './AddToTrolleySection'

import TuFulfilmentBlock from '../../components/TuFulfilmentBlock/TuFulfilmentBlock'
import TuBrandLogo from '../../components/TuBrandLogo/TuBrandLogo'
import Fit from '../../components/Fit/Fit'

import { getEssentialExtrasData } from '../../helpers/essentialExtrasHelper'

import * as Styled from './TuClothingPricingModuleSection.styles'

class TuClothingPricingModuleSection extends Component {
  render() {
    const {
      className,
      prices,
      creditPlansV5,
      genericFlagOptions,
      attributeSelectorOptions,
      fulfilmentBoxOptions,
      addToTrolleyButtonOptions,
      addToTrolleyStickyOptions,
      addToTrolleyModalOptions,
      wishListOptions,
      messageList,
      ratingSummary,
      brand,
      promotionOptions,
      matchingAccessoriesOptions,
      ESSENTIAL_EXTRAS,
      FREQUENTY_BROUHT_TOGETHER,
      WISHLIST,
      NECTAR,
      PAYPAL_IFC_MESSAGING,
      PAYPAL_MESSAGING,
      KLARNA_CREDITPLAN,
      KLARNA_MESSAGING,
      SHOW_ARGOSCARD_LOGO_FINANCE_ACCORDION,
      type,
      isTuMobileLayout,
      digitalDownload,
      brandLogoUrl
    } = this.props

    const { attributes: priceAttributes = {} } = prices || {}
    const { showAddToTrolley } = addToTrolleyButtonOptions

    const { availableProviders } = getPreferredCreditPlans(creditPlansV5)

    const trolleyOptions = {
      addToTrolleyStickyOptions,
      addToTrolleyModalOptions,
      addToTrolleyButtonOptions
    }

    const availabilityDataLayerOptions = {
      partNumbers: attributeSelectorOptions?.variants?.map(project.partNumber)
    }

    const orderSwatchProps = {
      orderMessage: 'Free fabric sample',
      SKU: attributeSelectorOptions.partNumber,
      showSwatch: attributeSelectorOptions.displaySwatchMessage
    }

    const tuFulfilmentBlockProps = {
      collectionInfoTitle: type === 'TU' ? 'Free Click & Collect' : 'Next day collection',
      deliveryInfoTitle: type === 'TU' ? 'Next and named day delivery' : 'Home delivery',
      returnInfoTitle: 'Free returns to store',
      collectionInfoDetails: type === 'TU' ? '' : '- Order before 2pm',
      deliveryInfoDetails: type === 'TU' ? '' : '- 1-2 days',
      collectionInfoValue: type === 'TU' ? '' : 'Free',
      deliveryInfoValue: type === 'TU' ? '' : '£3.95',
      type
    }

    const { essentialExtras } = genericFlagOptions

    const extrasData = getEssentialExtrasData(essentialExtras, matchingAccessoriesOptions)
    const isEssentialExtraEnabled = ESSENTIAL_EXTRAS && extrasData && showAddToTrolley

    return (
      <section className={className}>
        <Styled.PriceLogoContainer data-test='price-and-logo'>
          <ErrorBoundary>{prices ? <Price {...priceAttributes} /> : <Alert {...{ messageList }} />}</ErrorBoundary>
          <ErrorBoundary>
            <TuBrandLogo brand={brand} brandLogoUrl={brandLogoUrl} className='tu-logo' />
          </ErrorBoundary>
        </Styled.PriceLogoContainer>

        <Styled.TuMobileSectionAB>
          <Styled.FinanceSection isTuMobileLayout={isTuMobileLayout}>
            <FinanceAccordion
              title='Flexible credit available'
              PAYPAL_IFC_MESSAGING={PAYPAL_IFC_MESSAGING}
              showThirdPartyPayments={!digitalDownload}
              SHOW_ARGOSCARD_LOGO_FINANCE_ACCORDION={SHOW_ARGOSCARD_LOGO_FINANCE_ACCORDION}
              PAYPAL_MESSAGING={PAYPAL_MESSAGING}
              KLARNA_MESSAGING={KLARNA_MESSAGING}
              KLARNA_CREDITPLAN={KLARNA_CREDITPLAN}
              availableProviders={availableProviders}
            >
              {KLARNA_MESSAGING && (KLARNA_CREDITPLAN ? availableProviders.includes(KLARNA_PROVIDED) : true) && (
                <ErrorBoundary>
                  <KlarnaMessaging price={priceAttributes.now} dcid={KLARNA_MESSAGING.dcid} />
                </ErrorBoundary>
              )}

              {PAYPAL_MESSAGING && (
                <ErrorBoundary>
                  <PayPalContainer price={priceAttributes.now} />
                </ErrorBoundary>
              )}
            </FinanceAccordion>

            {NECTAR && (
              <ErrorBoundary>
                <PromotionContainer {...promotionOptions} />
              </ErrorBoundary>
            )}
          </Styled.FinanceSection>

          <Styled.OffersSection isTuMobileLayout={isTuMobileLayout}>
            <ErrorBoundary>
              <GenericFlag type='offers' {...genericFlagOptions} />
            </ErrorBoundary>
          </Styled.OffersSection>

          {FREQUENTY_BROUHT_TOGETHER && (
            <Styled.FreqBroughtTogether isTuMobileLayout={isTuMobileLayout}>
              <ErrorBoundary>
                <GenericFlag type='bundles' {...genericFlagOptions} />
              </ErrorBoundary>
            </Styled.FreqBroughtTogether>
          )}

          <Styled.OrderSwatch isTuMobileLayout={isTuMobileLayout}>
            <ErrorBoundary>
              <OrderSwatch {...orderSwatchProps} />
            </ErrorBoundary>
          </Styled.OrderSwatch>

          <Styled.Availability isTuMobileLayout={isTuMobileLayout}>
            <ErrorBoundary>
              <AvailabilityDataLayer {...availabilityDataLayerOptions}>
                <AttributeSelector
                  {...attributeSelectorOptions}
                  sizeGuide
                  brand={brand}
                  isTuMobileLayout={isTuMobileLayout}
                />
              </AvailabilityDataLayer>
            </ErrorBoundary>
          </Styled.Availability>

          {isTuMobileLayout && (
            <Styled.EMWBISSectionAB isTuMobileLayout={isTuMobileLayout}>
              <ErrorBoundary>
                <div id='email-portal' />
              </ErrorBoundary>
            </Styled.EMWBISSectionAB>
          )}

          <Styled.FitSection isTuMobileLayout={isTuMobileLayout}>
            <ErrorBoundary>
              <Fit ratingSummary={ratingSummary} />
            </ErrorBoundary>
          </Styled.FitSection>

          <Styled.AddToTrolley isTuMobileLayout={isTuMobileLayout}>
            <AddToTrolleySection {...trolleyOptions} />
          </Styled.AddToTrolley>
        </Styled.TuMobileSectionAB>

        {WISHLIST && (
          <ErrorBoundary>
            <WishList {...wishListOptions} />
          </ErrorBoundary>
        )}
        {type !== 'TU' && (
          <ErrorBoundary>
            <FulfilmentBoxContainer {...fulfilmentBoxOptions} />
          </ErrorBoundary>
        )}
        <ErrorBoundary>
          <TuFulfilmentBlock {...tuFulfilmentBlockProps} />
        </ErrorBoundary>

        {isEssentialExtraEnabled && (
          <ErrorBoundary>
            <EssentialExtras {...extrasData} />
          </ErrorBoundary>
        )}
      </section>
    )
  }
}

TuClothingPricingModuleSection.propTypes = {
  className: PropTypes.string.isRequired,
  prices: PropTypes.object.isRequired,
  creditPlansV5: PropTypes.object.isRequired,
  genericFlagOptions: PropTypes.object.isRequired,
  attributeSelectorOptions: PropTypes.object.isRequired,
  fulfilmentBoxOptions: PropTypes.object.isRequired,
  addToTrolleyButtonOptions: PropTypes.object.isRequired,
  addToTrolleyStickyOptions: PropTypes.object.isRequired,
  addToTrolleyModalOptions: PropTypes.object.isRequired,
  wishListOptions: PropTypes.object.isRequired,
  ratingSummary: PropTypes.object.isRequired,
  messageList: PropTypes.arrayOf(PropTypes.string).isRequired,
  brand: PropTypes.string.isRequired,
  promotionOptions: PropTypes.object.isRequired,
  ESSENTIAL_EXTRAS: PropTypes.bool.isRequired,
  FREQUENTY_BROUHT_TOGETHER: PropTypes.bool.isRequired,
  WISHLIST: PropTypes.bool.isRequired,
  NECTAR: PropTypes.bool.isRequired,
  PAYPAL_MESSAGING: PropTypes.bool.isRequired,
  KLARNA_MESSAGING: PropTypes.bool.isRequired,
  type: PropTypes.string.isRequired,
  isTuVariant: PropTypes.bool.isRequired
}

export default TuClothingPricingModuleSection
